import { render, staticRenderFns } from "./EditConta1.vue?vue&type=template&id=09c7f0ff&scoped=true&"
import script from "./EditConta1.vue?vue&type=script&lang=js&"
export * from "./EditConta1.vue?vue&type=script&lang=js&"
import style0 from "./EditConta1.vue?vue&type=style&index=0&id=09c7f0ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c7f0ff",
  null
  
)

export default component.exports